<div>
  <div class="add-title">
    <h2 class="primary" i18n="@@Add the Product to an Existing Inventory Item">Add the Product to an Existing Inventory Item</h2>
    <h3 class="primary">{{book?.title}}</h3>
  </div>
  <div class="identity">
    <span><span i18n="@@Book Id">Book Id</span>:&nbsp;{{bookId | numberFormat}}</span>
    <span *ngIf="product">&nbsp;&nbsp;<span i18n="@@Product">Product</span>:&nbsp;{{product.ID | numberFormat}}</span>
  </div>
  <div *ngIf="formGroup">
    <form [formGroup]="formGroup">
      <mat-form-field class="full-width">
        <mat-label i18n="@@Existing Inventory Item">Existing Inventory Item</mat-label>
        <mat-select formControlName="facilityInventoryProduct_ID" required>
          <mat-option *ngFor="let candidate of selectableCandidates" [value]="candidate.ID">
            <span i18n="@@Facility">Facility</span>&nbsp;{{candidate.printnode_ID | numberFormat}}
            &nbsp;&ndash;&nbsp;{{getTitle(candidate)}}
            <span style="margin-inline-start: 6px; color: #888; font-size: smaller;">{{candidate.location}} {{candidate.shelf}}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="message" *ngIf="looking" i18n="@@Looking for the Product for this Book Id.">Looking for the Product for this Book Id.</div>
      <div class="errorMessage" *ngIf="productNotFound" i18n="@@Could not find a Product for this Book Id.">Could not find a Product for this Book Id.</div>
      <div class="errorMessage" *ngIf="saveFailed" i18n="@@The Product could not be added to the inventory item.">The Product could not be added to the inventory item.</div>
      <div class="message" *ngIf="selectableCandidates.length === 0" i18n="@@No existing inventory item in this Project can take this Product.">No existing inventory item in this Project can take this Product.</div>
      <div class="btn-sec">
        <button mat-raised-button type="button" class="Discard-btn" mat-dialog-close="" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
        <button mat-raised-button type="button" color="primary" class="Update-btn" [disabled]="formGroup.invalid || !product || saving" (click)="onAdd()" i18n="@@Add">Add</button>
      </div>
    </form>
  </div>
</div>


